export default __webpack_public_path__ + "static/subscribe-0dc0fdbe83e79d9c1bd6d32631471930.png";